import BaseDataObject from './BaseDataObject';
import BaseReduction from './BaseReduction';

export default class ABCDReduction extends BaseReduction {
  constructor() {
    super(...arguments);
    this.ensureArray('abcdMethods');
  }

  isEmpty() {
    const num = this.getNumberOfABCDMethods();
    for (let n = 0; n < num; n++) {
      if (!this.getABCDMethod(n).isEmpty()) {
        return false;
      }
    }

    return true;
  }

  getNumberOfABCDMethods() {
    return this.getNumberOf('abcdMethods');
  }

  getABCDMethod(index) {
    return this.getObject('abcdMethods', ABCDReductionMethod, index);
  }

  addABCDMethod() {
    this.invalidate();
    return this.addObject('abcdMethods', ABCDReductionMethod);
  }

  deleteABCDMethod(index) {
    this.invalidate();
    return this.deleteObject('abcdMethods', index);
  }
}

class ABCDReductionMethod extends BaseDataObject {
  constructor() {
    super(...arguments);
    this.ensureArray('abcdMethodRows');
  }

  isEmpty() {
    const num = this.getNumberOfABCDMethodRows();
    for (let n = 0; n < num; n++) {
      if (!this.getABCDMethodRow(n).isEmpty()) {
        return false;
      }
    }

    return true;
  }

  getABCDMethodRows() {
    return this.getObjects('abcdMethodRows', ABCDReductionMethodRow);
  }
  getABCDMethodRow(index) {
    return this.getObject('abcdMethodRows', ABCDReductionMethodRow, index);
  }
  getNumberOfABCDMethodRows() {
    return this.getNumberOf('abcdMethodRows');
  }
  addABCDMethodRow() {
    this.invalidate();
    return this.addObject('abcdMethodRows', ABCDReductionMethodRow);
  }
  deleteABCDMethodRow(index) {
    this.invalidate();
    return this.deleteObject('abcdMethodRows', index);
  }
  getFactor() {
    return this.getInteger('factor', 1);
  }
  setFactor(v) {
    // Anything falsy must be transformed to 1. Factor 0 not allowed.
    const ensuredFactorValue = Math.max(v, 1);
    this.invalidate();
    return this.setInteger('factor', ensuredFactorValue);
  }
}

class ABCDReductionMethodRow extends BaseDataObject {
  constructor() {
    super(...arguments);
    this.ensureArray('legNumbers');
    this.ensureInteger('minPoints', -1);
    this.ensureInteger('maxPoints', -1);
  }

  isEmpty() {
    if (this.getMinPoints() === -1 && this.getMaxPoints() === -1) {
      return true;
    } else if (this.getLegNumbers().length === 0) {
      return true;
    } else {
      return false;
    }
  }

  getMinPoints() {
    return this.getInteger('minPoints', -1);
  }
  setMinPoints(v) {
    this.invalidate();
    return this.setInteger('minPoints', v);
  }

  getMaxPoints() {
    return this.getInteger('maxPoints', -1);
  }

  setMaxPoints(v) {
    this.invalidate();
    return this.setInteger('maxPoints', v);
  }

  getLetter() {
    return this.getString('letter');
  }

  setLetter(v) {
    this.invalidate();
    return this.setString('letter', v);
  }

  getLegNumbers() {
    return this.getIntegerArray('legNumbers');
  }

  setLegNumbers(v) {
    this.invalidate();
    return this.setIntegerArray('legNumbers', v);
  }
}
